// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"Card_cardTitle__3_8Ed","cardDataLabel":"Card_cardDataLabel__1EDAi","cardData":"Card_cardData__2ox_5","total":"Card_total__2Eu0X"};